import React from 'react';
import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';

import { FilterBarSettings } from '../filterBarSettings';

import PinnedFiltersSettings from './PinnedFiltersSettings';

const PinnedFiltersModal = ({
  settings,
  isOpen,
  close,
}: {
  settings: FilterBarSettings;
  isOpen: boolean;
  close: () => void;
}) => (
  <ModalTransition>
    {isOpen && (
      <ModalDialog
        onClose={close}
        shouldScrollInViewport={false}
        autoFocus={false}
      >
        <PinnedFiltersSettings settings={settings} close={close} />
      </ModalDialog>
    )}
  </ModalTransition>
);

export default PinnedFiltersModal;
